import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Invoice } from '../invoicesTypes';
import { InvoiceStatusBadge } from './InvoiceStatusBadge';
import styles from './InvoiceTable.module.css';

interface InvoiceTableProps {
  items: Invoice[];
}

export const InvoiceTable: React.FC<InvoiceTableProps> = ({ items }) => {
  const navigate = useNavigate();
  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>INVOICE #</th>
            <th>CUSTOMER</th>
            <th>ORDER #</th>
            <th>ISSUE DATE</th>
            <th>DUE DATE</th>
            <th className={styles.right}>AMOUNT</th>
            <th className={styles.right}>BALANCE</th>
            <th>STATUS</th>
            <th>ACTION</th>
          </tr>
        </thead>
        <tbody>
          {items.length === 0 ? (
            <tr>
              <td colSpan={9} className={styles.emptyState}>No invoices found.</td>
            </tr>
          ) : (
            items.map((inv, idx) => {
              const balanceColor =
                inv.status === 'Paid'
                  ? '#16A34A'
                  : inv.status === 'Partial' || inv.status === 'Overdue'
                  ? '#DC2626'
                  : '#1F2937';

              return (
                <tr key={idx}>
                  <td>
                    <span className={styles.invoiceLink}>{inv.invoiceNumber}</span>
                  </td>
                  <td className={styles.customerName}>{inv.customer}</td>
                  <td className={styles.orderNumber}>{inv.orderNumber}</td>
                  <td>{inv.issueDate}</td>
                  <td className={inv.dueDateOverdue ? styles.dueDateOverdue : ''}>
                    {inv.dueDate}
                  </td>
                  <td className={styles.right}>{inv.amount}</td>
                  <td className={styles.right}>
                    <span style={{ color: balanceColor, fontWeight: 600 }}>{inv.balance}</span>
                  </td>
                  <td>
                    <InvoiceStatusBadge status={inv.status} />
                  </td>
                  <td>
                    <button
                      type="button"
                      className={styles.viewBtn}
                      onClick={() => navigate('/payments')}
                    >
                      View
                    </button>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
};
